import { flexRender } from '@tanstack/react-table'
import { useVirtual } from 'react-virtual'
import { Loader } from '../V3/_shared/Loader'

type MetaType = {
  alignmentType?: string
}

export function Table({ table, isLoading = true, tableContainerRef }) {
  const { rows } = table.getRowModel()
  const rowVirtualizer = useVirtual({
    parentRef: tableContainerRef,
    size: rows.length,
    overscan: rows.length,
  })

  const { virtualItems: virtualRows } = rowVirtualizer

  return (
    <div className="max-h-[400px] overflow-y-auto z-10">
      <table className="w-full">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    className="bg-[#F4F7FF] text-[#0D4BCC] font-normal border-[1px] py-4 text-left px-4"
                    key={header.id}
                    data-type={`${
                      header?.column.columnDef && (header?.column.columnDef.meta as MetaType).alignmentType
                    }`}
                    colSpan={header.colSpan}
                    style={{ width: header.getSize() }}
                  >
                    <div
                      {...{
                        className: header.column.getCanSort()
                          ? `cursor-pointer select-none sorted-${header?.column?.getIsSorted() as string}`
                          : '',
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {{
                        asc: '',
                        desc: '',
                        default: '',
                      }[header.column.getIsSorted() as string] ?? null}
                    </div>
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {isLoading
            ? null
            : virtualRows.map((virtualRow) => {
                const row = rows[virtualRow.index]
                return (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td
                          className="p-4 border-[1px] bg-white capitalize"
                          key={cell.id}
                          data-type={`${
                            cell?.column.columnDef && (cell?.column.columnDef.meta as MetaType).alignmentType
                          }`}
                        >
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
        </tbody>
      </table>
      {isLoading && (
        <div className="w-full gap-2 h-[200px] flex-col bg-white flex items-center justify-center">
          <Loader />
          <span>Henter data</span>
        </div>
      )}
    </div>
  )
}
